<template>
  <component :is="tag" class="html-content" v-html="html"></component>
</template>

<script setup>
defineProps({
  html: {
    type: String,
    // TODO(#26707): restore `required: true` (drop the default) once the
    // decision-tree API contract guarantees non-null html on every node
    default: "",
  },
  tag: {
    type: String,
    default: "div",
  },
});
</script>

<style lang="scss" scoped>
.html-content {
  &:deep(*) {
    margin-bottom: 0;
  }

  &:deep(> * + *) {
    margin-top: 1rem !important;
  }

  &:deep(> *:first-child) {
    margin-top: 0 !important;
  }

  &:deep(ul) {
    list-style: var(--sp-comp-dtv-html-content-ul-li-style, disc);
    list-style-position: var(--sp-comp-dtv-html-content-ul-li-style-position, inside);
  }

  &:deep(ol) {
    list-style: var(--sp-comp-dtv-html-content-ol-li-style, decimal);
    list-style-position: var(--sp-comp-dtv-html-content-ol-li-style-position, inside);
    padding-inline-start: var(--sp-comp-dtv-html-content-ol-padding-inline-start, 0);
  }

  &:deep(strong) {
    font-family: var(--sp-comp-dtv-html-content-strong-font, inherit);
    font-weight: var(--sp-comp-dtv-html-content-strong-font-weight, bolder);
  }

  &:deep(em) {
    font-family: var(--sp-comp-dtv-html-content-em-font, inherit);
    font-weight: var(--sp-comp-dtv-html-content-em-font-weight, normal);
    font-style: var(--sp-comp-dtv-html-content-em-font-style, italic);
  }

  &:not(.node__title):deep(p) {
    font: var(--sp-comp-dtv-html-content-p-font, var(--sp-sys-typescale-body-short));
  }
}
</style>
